export const categorizeGetListCatering = (listFromGetListCatering) => {
  const categorizedCateringList = {}

  listFromGetListCatering.forEach((item) => {
    if (item.type in categorizedCateringList) {
      const tempList = {...categorizedCateringList[item.type]}
      categorizedCateringList[item.type] = {
        ...tempList,
        [item.itemId]: {...item, ...(_setItemAmount(item))},
      }
    } else {
      categorizedCateringList[item.type] = {
        [item.itemId]: {...item, ...(_setItemAmount(item))}
      }
    }
  })  

  return categorizedCateringList
}

const _setItemAmount = (item) => {
  if (!item.amount) {
    return { amount: 0 }
  }
}
